






















import { injectable } from 'inversify';
import { Vue, Component, Prop } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import * as Api from "@/app/question/components/api";
import { SortingAnswer } from './sorting-interfaces';
import { SortingCorrectAnswer, AnswerItem } from './sorting-question-component.vue';

@Component
export default class SortingQuestionSolutionComponent extends Vue implements Api.QuestionSolutionProps2<SortingAnswer, SortingCorrectAnswer> {

  @Prop({
    required: true,
  })
  public userAnswer: SortingAnswer;

  @Prop({
    required: true,
  })
  public correctAnswer: SortingCorrectAnswer;

  private get answersOrder(): AnswerItem[] {
    let answers: AnswerItem[] = [];

    this.userAnswer.answerIdsOrder.forEach((id: string) => {
      const foundAnswer = this.correctAnswer.find((a) => a.id === id);
      if (foundAnswer) {
        answers = [...answers, foundAnswer];
      }
    });

    return answers;
  }

  private get correctAnswerOrder(): string[] {
    return this.correctAnswer.map((a) => a.answer);
  }

  private get correctAnswerIdsOrder(): string[] {
    return this.correctAnswer.map((a) => a.id);
  }

  private inCorrectIndex(id: string, index: number): boolean {
    const correctIndex = this.correctAnswerIdsOrder.findIndex((a) => a === id);
    return correctIndex === index;
  }

  private t(key: string, params: any = {}) {
    return i18n.t(key, params);
  }
}
